  <div class="p-3 mb-4 bg-light rounded-3">
  <div class="mb-4 row">
    <div class="col-12 mb-3">
        <div class="titletoptables">
          <div class="leftsideicons">
            <img src="../../assets/image/Report-icon.png" alt="report" onkeydown=""/>
          </div>
          <h3>Reports</h3>
        </div>
      </div>
    </div>
    <div class="grid-card">
      <app-data-grid>
      <kendo-grid [data]="dropdownValues" (cellClick)="navigateToReports($event.dataItem)">
        <kendo-grid-column title=" " [includeInChooser]="false" [width]="40" [sortable]="false" [filterable]="false" [columnMenu]="false"
          headerClass="col-action" class="col-action">
          <ng-template kendoGridCellTemplate>
            <div class="text-center">
              <div class="mx-2 d-inline-block">
                <span class="verical_menu" aria-hidden="true">
                  <kendo-svg-icon [icon]="icons.view"></kendo-svg-icon>
                </span>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="#" [width]="60" [sortable]="false" [filterable]="false" [columnMenu]="false">
          <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
            {{ rowIndex + 1 }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Name" title="Report Name">
        </kendo-grid-column>
      </kendo-grid>
      </app-data-grid>
    </div>
  </div>
